export * from './tabs-panel';
